import { useState } from "react";
import useWexClient from "./Clients/wexClient,";

const useReports = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const {getFoliosReports} = useWexClient();

  const fetchFoliosReport = async (filters) => {
    setLoading(true);
    try {
      const response = await getFoliosReports(filters);

      if (response?.success === true) {
        setData(response.data || []);
      } 
      if (response?.success === false) {
        setData([]);
        console.error(response?.message);
      }
      if (!response){
        return;
      }
    } catch (error) {
      console.error(error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    fetchFoliosReport,
  };
};

export default useReports;